<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
-->

<template>
  <div>
    <div class="app-register-title"><slot name="header-title" /></div>

    <div class="app-register-description">
      <slot name="header-description" />
    </div>

    <div class="app-registration-content"><slot name="content" /></div>
  </div>
</template>

<script>
export default {
  name: "RegistrationTemplate"
}
</script>

<style lang="scss" scoped>
.app-register-title > h1 {
  @extend .color-title-black;
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 0.8rem;
}

.app-register-description > h3 {
  @extend .color-title-black;
  max-width: 39rem;
  margin: 0 auto;
  font-weight: 400;
  line-height: 2rem;
}

.app-registration-content {
  @include app-ec-card;
  max-width: 40rem;
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Registration-Template.vue